import { render, staticRenderFns } from "./eshop-cart.vue?vue&type=template&id=0228130a&scoped=true&"
import script from "./eshop-cart.vue?vue&type=script&lang=js&"
export * from "./eshop-cart.vue?vue&type=script&lang=js&"
import style0 from "./eshop-cart.vue?vue&type=style&index=0&id=0228130a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0228130a",
  null
  
)

export default component.exports